// src/features/payments/pages/PaymentDetails.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getPaymentById } from "../api";

const row = (label, value) => (
  <tr>
    <th style={{ textAlign: "right", width: 200 }}>{label}</th>
    <td>{value ?? "-"}</td>
  </tr>
);

const PaymentDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const d = await getPaymentById(id);
        setData(d);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) return <div className="sa-page"><h1>Payment Details</h1>Loading…</div>;
  if (!data) return <div className="sa-page"><h1>Payment Details</h1>Not found.</div>;

  return (
    <div className="sa-page">
      <div className="sa-head">
        <h1>Payment Details</h1>
        <Link to="/super-admin/payments" className="sa-btn-outline">Back</Link>
      </div>

      <div className="sa-table-wrap">
        <table className="sa-kv">
          <tbody>
            {row("Booking ID", data.bookingId)}
            {row("Venue", data.venue?.name || data.venueName)}
            {row("User", data.user?.fullName || data.userName)}
            {row("Payment Status", data.paymentStatus)}
            {row("Total Amount", `₹ ${data.totalAmount}`)}
            {row("Commission %", `${data.commissionPercent}%`)}
            {row("Commission", `₹ ${data.commissionAmount}`)}
            {row("Gateway Fee", `₹ ${data.gatewayFee}`)}
            {row("Net Commission", `₹ ${data.netCommission}`)}
            {row("Venue Settlement", `₹ ${data.venueSettlement}`)}
            {row("Paid At", data.paidAt ? new Date(data.paidAt).toLocaleString() : "-")}
            {row("Reservation Id", data.reservation?._id)}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentDetails;
